import React from "react";
import { connect } from "react-redux";
import Card from "react-md/lib/Cards/Card";
import CardText from "react-md/lib/Cards/CardText";
import {map, isEmpty, size} from "lodash";
import { Button, FontIcon } from "react-md";
import ProjectsList from "../../components/projects/List";

import Carousel from "../Carousel";
import {TouchTableHeader} from "../../AtollonTheme/ReactElements";

const Projects = ({ history, projects }) => {
  return (
    <div>
        <TouchTableHeader
            title={"Moje projekty"}
            titleNumber={projects && !isEmpty( projects.item ) ? size( projects.item ) : 0}
            titleButtons={(
                <Button
                    raised
                    className="btn btn-primary touchButton-4 touchButton-shape3"
                    label="Přidat projekt"
                    onClick={() => history.push("/project-new")}
                />
            )}
        />

        <div style={{width:'100%'}}>
            <ProjectsList history={history} projects={projects} />
        </div>
    </div>
  );
};

export default connect(({ resource: { projects } }) => ({ projects }), null)(
  Projects
);



// WEBPACK FOOTER //
// ./src/components/main/Projects.js